import { AnyAction } from "redux";
import {
    FETCH_CASH_CYCLES, RECEIVE_CASH_CYCLES,
    FETCH_CURRENT_CASH_CYCLE, RECEIVE_CURRENT_CASH_CYCLE,
    SAVE_CASH_CYCLE, SAVE_CASH_CYCLE_SUCCESS,
    FETCH_CYCLE_DETAILS, RECEIVE_CYCLE_DETAILS,
    SAVE_CASH_TRANSACTION, SAVE_CASH_TRANSACTION_SUCCESS,
    FETCH_FINANCIAL_DASHBOARD, RECEIVE_FINANCIAL_DASHBOARD
} from "../actionTypes";

interface FinancialState {
    isFetchingCycles: boolean;
    isFetchingCurrentCycle: boolean;
    isSavingCycle: boolean;
    isFetchingDetails: boolean;
    isSavingTransaction: boolean;
    isFetchingDashboard: boolean;
    cashCycles: any[];
    currentCashCycle: any;
    cycleDetails: any[];
    financialDashboard: any;
}

const initialState: FinancialState = {
    isFetchingCycles: false,
    isFetchingCurrentCycle: false,
    isSavingCycle: false,
    isFetchingDetails: false,
    isSavingTransaction: false,
    isFetchingDashboard: false,
    cashCycles: [],
    currentCashCycle: null,
    cycleDetails: [],
    financialDashboard: null,
}

const financialReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case FETCH_CASH_CYCLES: return { ...state, isFetchingCycles: true };
        case RECEIVE_CASH_CYCLES: return { ...state, isFetchingCycles: false, cashCycles: action.payload };
        case FETCH_CURRENT_CASH_CYCLE: return { ...state, isFetchingCurrentCycle: true };
        case RECEIVE_CURRENT_CASH_CYCLE: return { ...state, isFetchingCurrentCycle: false, currentCashCycle: action.payload };
        case SAVE_CASH_CYCLE: return { ...state, isSavingCycle: true };
        case SAVE_CASH_CYCLE_SUCCESS: return { ...state, isSavingCycle: false };
        case FETCH_CYCLE_DETAILS: return { ...state, isFetchingDetails: true };
        case RECEIVE_CYCLE_DETAILS: return { ...state, isFetchingDetails: false, cycleDetails: action.payload };
        case SAVE_CASH_TRANSACTION: return { ...state, isSavingTransaction: true };
        case SAVE_CASH_TRANSACTION_SUCCESS: return { ...state, isSavingTransaction: false };
        case FETCH_FINANCIAL_DASHBOARD: return { ...state, isFetchingDashboard: true };
        case RECEIVE_FINANCIAL_DASHBOARD: return { ...state, isFetchingDashboard: false, financialDashboard: action.payload };
        default: return state;
    }
}
export default financialReducer;
